module.exports = __webpack_public_path__ + "components/flag/static/square/be-58b0f8c404a97a2cc8ecc29283a01a54.svg";